import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AvatarModule } from 'ngx-avatar';
import { ChatInputComponent } from './chat-input.component';
import {TextareaAutosizeModule} from 'ngx-textarea-autosize';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    AvatarModule,
    TextareaAutosizeModule
  ],
  declarations: [
    ChatInputComponent
  ],
  exports: [
    ChatInputComponent // <-- this!
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class ChatInputModule {}